import { Component, Vue } from "vue-property-decorator";
import { gql } from "graphql-tag";
import RadioButtonComponent from "../radio-button/radio-button.component.vue";
import SignatureSubmissionComponent from "../signature-submission/signature-submission.component.vue";
import AppLoaderComponent from "../app-loader/app-loader.component.vue";
import { EMPLOYMENT_SUMMARY_FORM_QUERY } from "@/graphql/employment-summary-form-query";
import {
  EmploymentSummariesForm,
  FormFieldContents,
} from "@/models/employment-summary-form/employment-summary-form.interface";
import { employmentVolunteerFormApi } from "@/providers/apis/employment-volunteer-form";
import moment from "moment";
import { utils } from "@/utils/utils";
import ErrorPopupComponent from "../error-popup/error-popup.component.vue";
import FormInputDatepickerComponent from "../form-input-datepicker/form-input-datepicker.component.vue";

@Component({
  name: "certification-form",
  components: {
    "b-form-radio-group": RadioButtonComponent,
    "b-form-signature-submission": SignatureSubmissionComponent,
    "b-form-input-datepicker": FormInputDatepickerComponent,
    AppLoaderComponent,
    ErrorPopupComponent,
  },
})
export default class EmploymentSummaryForm extends Vue {
  public formPagination = 0;
  public formNames = ["employmentApplicantInformation"];
  public applicationData: Array<EmploymentSummariesForm> = [];
  public formData: FormFieldContents[] = [];
  public isScroll = false;
  public isValid = false;
  public signatureInvalid = false;
  public saveDataDraft = false;
  public errorMessage = "";
  public checkValidForm = false;
  public volunteerOfInformation: any;
  public supervisorOfInformation: any;
  public supervisorData: any;
  public payLoadData: any = {
    fillStatus: "DRAFT",
    id: "",
    employmentApplicantInformation: {
      firstName: "",
      lastName: "",
      jobTitle: "",
      hours: "",
      employedVolunteering: "",
    },
    supervisorContactInformation: {
      firstName: "",
      lastName: "",
      employmentDirectServiceRole: "",
      employmentPosition: "",
      DateOfEmployment: "",
      employmenthoursPerWeek: "",
      employmentCredentials: "",
      organization: "",
      position: "",
      phone: "",
      email: "",
      addressLine1: "",
      addressLine2: "",
      state: "",
      city: "",
      zip: "",
      workResponsibilities: "",
      natureOfYourDirect: "",
      professionalDevelopment: "",
    },
    volunteerSummaryInformation: {
      firstName: "",
      lastName: "",
      volunteerDirectServiceRole: "",
      volunteerPosition: "",
      startDate: "",
      hoursPerWeek: "",
      volunteerCredentials: "",
      organization: "",
      position: "",
      phone: "",
      email: "",
      addressLine1: "",
      addressLine2: "",
      state: "",
      city: "",
      zip: "",
      volunteerResponsibilities: "",
      volunteerInteractions: "",
      volunteerGoalsAgency: "",
    },
    signature: {
      isSignature: "",
      submissionDate: moment().format("MM-DD-YYYY"),
    },
  };
  public mainId = "app";
  public hideDiv: string[] = ["supervisorEmployment"];
  public checkField: string[] = ["volunteerOrApprovedAgency"];
  public formTitle = {
    main_title: "",
    application_name: "",
  };
  public isLoading = false;
  public token: any;
  public applicationDetials: any;
  public applicationDataDetials: any;
  public eventBind: any = {
    acceptNumberOnly: this.numberValidation,
    avoidNumbersAndSpecialChar: this.avoidNumbersAndSpecialCharacter,
    telCharacter: this.telCharacterValidate,
    onlyAlphabets: this.onlyAlphabets,
  };

  public async created() {
    this.token = this.$route.query?.token;
    let payloadStorage: any = localStorage.getItem("employmentPayLoadData");
    if (payloadStorage) {
      payloadStorage = JSON.parse(payloadStorage);
      this.payLoadData = { ...payloadStorage };
    }
    this.$apollo
      .query({
        query: gql`query ${EMPLOYMENT_SUMMARY_FORM_QUERY}`,
      })
      .then((result) => {
        this.applicationData = result.data.employmentSummaries.data;
        this.formTitle = {
          main_title: this.applicationData[0].attributes.main_title,
          application_name: this.applicationData[0].attributes.application_name,
        };
        this.formData = this.applicationData[0].attributes.form_fields;
      });
    if (this.token) {
      if (
        this.payLoadData.employmentApplicantInformation.employedVolunteering
      ) {
        if (
          this.payLoadData.employmentApplicantInformation
            .employedVolunteering === "employed with your organization"
        ) {
          this.formNames = [
            "employmentApplicantInformation",
            "supervisorContactInformation",
            "signature",
          ];
        } else {
          this.formNames = [
            "employmentApplicantInformation",
            "volunteerSummaryInformation",
            "signature",
          ];
        }
      }
      this.isLoading = true;
      employmentVolunteerFormApi
        .getEmploymentVolunteerForm(this.token)
        .then((result: any) => {
          this.isLoading = false;
          this.applicationDetials = result.data;
          this.applicationDataDetials =
            this.applicationDetials.data.certificationPartTwoApplicationForm;
          const decodeToken = JSON.parse(atob(this.token.split(".")[1]));
          const emailData = decodeToken.email;
          if (this.applicationDetials) {
            this.payLoadData.employmentApplicantInformation.firstName =
              this.applicationDataDetials.firstName;
            this.payLoadData.employmentApplicantInformation.lastName =
              this.applicationDataDetials.lastName;
            this.payLoadData.employmentApplicantInformation.applicantPositionTitle =
              this.applicationDataDetials.position;

            this.supervisorOfInformation =
              result.data.data.certificationPartTwoSupervisorInformation;
            this.supervisorOfInformation.map((data: any) => {
              this.supervisorData = data;
              if (data.supervisorEmail == emailData) {
                this.payLoadData.supervisorContactInformation.firstName =
                  this.supervisorData.supervisorFirstName;
                this.payLoadData.supervisorContactInformation.lastName =
                  this.supervisorData.supervisorLastName;
                this.payLoadData.supervisorContactInformation.organization =
                  this.supervisorData.peerSupportAgencyOrganization;
                this.payLoadData.supervisorContactInformation.position =
                  this.supervisorData.peerSupportYourPosition;
                this.payLoadData.supervisorContactInformation.employmentCredentials =
                  this.supervisorData.supervisorCredentials;
                this.payLoadData.supervisorContactInformation.phone =
                  this.supervisorData.phone;
                this.payLoadData.supervisorContactInformation.email =
                  this.supervisorData.supervisorEmail;
              }
            });

            this.volunteerOfInformation =
              result.data.data.certificationPartTwoSupervisorInformation;
            this.supervisorOfInformation.map((data: any) => {
              this.supervisorData = data;
              if (data.supervisorEmail == emailData) {
                this.payLoadData.volunteerSummaryInformation.firstName =
                  this.supervisorData.supervisorFirstName;
                this.payLoadData.volunteerSummaryInformation.lastName =
                  this.supervisorData.supervisorLastName;
                this.payLoadData.volunteerSummaryInformation.startDate =
                  this.supervisorData.startDate;
                this.payLoadData.volunteerSummaryInformation.volunteerCredentials =
                  this.supervisorData.supervisorCredentials;
                this.payLoadData.volunteerSummaryInformation.agencyOrOrganization =
                  this.supervisorData.peerSupportAgencyOrganization;
                this.payLoadData.volunteerSummaryInformation.phone =
                  this.supervisorData.phone;
                this.payLoadData.volunteerSummaryInformation.email =
                  this.supervisorData.supervisorEmail;
              }
            });
          }
          localStorage.setItem(
            "employmentPayLoadData",
            JSON.stringify(this.payLoadData)
          );
        })
        .catch((error) => {
          this.errorMessage = utils.errorMessage(error);
          this.isLoading = false;
        });
    }
  }

  public fieldUpdate(groupName = "", initial = false) {
    switch (groupName) {
      case "employedVolunteering":
        if (
          this.payLoadData.employmentApplicantInformation
            .employedVolunteering === "employed with your organization"
        ) {
          this.formNames = [
            "employmentApplicantInformation",
            "supervisorContactInformation",
            "signature",
          ];
        } else {
          this.formNames = [
            "employmentApplicantInformation",
            "volunteerSummaryInformation",
            "signature",
          ];
        }
        break;
    }
  }

  public saveDraft() {
    this.$bvToast.show("example-toast");
    localStorage.setItem(
      "employmentPayLoadData",
      JSON.stringify(this.payLoadData)
    );
    this.saveDataDraft = true;

    setTimeout(() => {
      this.saveDataDraft = false;
    }, 1000);
  }

  public fieldUpdateReference(inputName: string) {
    const nameNotVisiable = ["fullName", "fullAddress"];
    return nameNotVisiable.includes(inputName);
  }

  public onSubmit() {
    this.checkValidForm = true;
    this.$validator.validate().then((validate) => {
      if (validate) {
        if (this.payLoadData.signature.isSignature) {
          this.signatureInvalid = false;
        } else {
          this.signatureInvalid = true;
          setTimeout(() => {
            const el = document.getElementsByClassName("is-invalid")[0];
            if (el) {
              el.scrollIntoView({ behavior: "smooth", block: "end" });
            }
          }, 10);
          return;
        }

        localStorage.setItem(
          "employmentPayLoadData",
          JSON.stringify(this.payLoadData)
        );
        this.isLoading = true;
        const el = document.getElementById(this.mainId);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
        let payloadStorage: any = localStorage.getItem("employmentPayLoadData");
        if (payloadStorage) {
          payloadStorage = JSON.parse(payloadStorage);
          this.payLoadData = { ...payloadStorage };
        }
        employmentVolunteerFormApi
          .postEmploymentApplicationForm(this.token, this.payLoadData)
          .then(() => {
            this.checkValidForm = false;
            const someData = {
              title: "Certified Family Support Specialist Program",
              SubTitle: "Employment / Volunteer Form",
            };
            this.$router.push({
              path: "/form/submitted",
              query: {
                subTitle: someData.SubTitle,
              },
            });
            localStorage.removeItem("employmentPayLoadData");
            this.isLoading = false;
          })
          .catch((error) => {
            this.errorMessage = utils.errorMessage(error);
            this.isLoading = false;
          });
      } else {
        const el = document.getElementsByClassName("is-invalid")[0];
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "end" });
        }
      }
    });
  }

  public closePopup() {
    this.$bvModal.hide("modal-center");
  }

  public numberValidation(evt: any, length?: number) {
    utils.onlyNumberKey(evt, length);
  }

  public avoidNumbersAndSpecialCharacter(evt: any) {
    utils.avoidNumbersAndSpecialCharacters(evt);
  }

  public telCharacterValidate(evt: any, length?: number) {
    utils.telCharacterValidate(evt, length);
  }

  public onlyAlphabets(evt: any, fieldName = "") {
    utils.onlyAlphabets(evt, fieldName);
  }

  // Number field validation for numeric values
  public numberSpecialCharacterValidation(event: any, formInput: any) {
    utils.preventNumeric(event, formInput);
  }

  public fieldValidation(
    value: any,
    eventName: string,
    fieldType: string,
    maxLength = 0,
    fieldName = ""
  ) {
    if (fieldType === "number") {
      this.eventBind[eventName](value, maxLength);
    } else if (fieldName === "state") {
      this.eventBind[eventName](value, fieldName);
    } else {
      this.eventBind[eventName](value);
    }
  }

  public closdedErrorPopup(event: any) {
    if (event) {
      this.errorMessage = "";
    }
  }

  public emptyEvent() {
    return;
  }

  public closeToast() {
    this.$bvToast.hide("example-toast");
  }

  public classNameChooser(inputClass: string) {
    return utils.classNameChooser(inputClass);
  }
}
